// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "stcs_wapp";

/** v1.0.0 */
export interface WappRemoteCfg {
  ui: UiRemoteCfg | undefined;
  stripe: StripeRemoteCfg | undefined;
  wapp_core_cfg: WappCoreCfg | undefined;
}

export interface UiRemoteCfg {
  dashboard: UiRemoteCfgtem | undefined;
  plan: UiRemoteCfgtem | undefined;
  financials: UiRemoteCfgtem | undefined;
  analysis: StripeRemoteCfgAnalysis | undefined;
  settings: UiRemoteCfgtem | undefined;
  settings_billing: UiRemoteCfgtem | undefined;
}

export interface UiRemoteCfgtem {
  active: boolean;
}

export interface StripeRemoteCfg {
  payment_url_annually: string;
  payment_url_monthly: string;
  payment_url_customer_portal: string;
}

export interface WappCoreCfg {
  lp_url: string;
}

export interface StripeRemoteCfgAnalysis {
  active: boolean;
  sub_section_map: StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection | undefined;
}

export interface StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection {
  pnl: boolean;
  revenues: boolean;
  cf_n_debt: boolean;
  nwc: boolean;
  bs: boolean;
  kpis: boolean;
  accounts: boolean;
}

function createBaseWappRemoteCfg(): WappRemoteCfg {
  return { ui: undefined, stripe: undefined, wapp_core_cfg: undefined };
}

export const WappRemoteCfg: MessageFns<WappRemoteCfg> = {
  encode(message: WappRemoteCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ui !== undefined) {
      UiRemoteCfg.encode(message.ui, writer.uint32(10).fork()).join();
    }
    if (message.stripe !== undefined) {
      StripeRemoteCfg.encode(message.stripe, writer.uint32(18).fork()).join();
    }
    if (message.wapp_core_cfg !== undefined) {
      WappCoreCfg.encode(message.wapp_core_cfg, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WappRemoteCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWappRemoteCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ui = UiRemoteCfg.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stripe = StripeRemoteCfg.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.wapp_core_cfg = WappCoreCfg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WappRemoteCfg {
    return {
      ui: isSet(object.ui) ? UiRemoteCfg.fromJSON(object.ui) : undefined,
      stripe: isSet(object.stripe) ? StripeRemoteCfg.fromJSON(object.stripe) : undefined,
      wapp_core_cfg: isSet(object.wapp_core_cfg) ? WappCoreCfg.fromJSON(object.wapp_core_cfg) : undefined,
    };
  },

  toJSON(message: WappRemoteCfg): unknown {
    const obj: any = {};
    if (message.ui !== undefined) {
      obj.ui = UiRemoteCfg.toJSON(message.ui);
    }
    if (message.stripe !== undefined) {
      obj.stripe = StripeRemoteCfg.toJSON(message.stripe);
    }
    if (message.wapp_core_cfg !== undefined) {
      obj.wapp_core_cfg = WappCoreCfg.toJSON(message.wapp_core_cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WappRemoteCfg>, I>>(base?: I): WappRemoteCfg {
    return WappRemoteCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WappRemoteCfg>, I>>(object: I): WappRemoteCfg {
    const message = createBaseWappRemoteCfg();
    message.ui = (object.ui !== undefined && object.ui !== null) ? UiRemoteCfg.fromPartial(object.ui) : undefined;
    message.stripe = (object.stripe !== undefined && object.stripe !== null)
      ? StripeRemoteCfg.fromPartial(object.stripe)
      : undefined;
    message.wapp_core_cfg = (object.wapp_core_cfg !== undefined && object.wapp_core_cfg !== null)
      ? WappCoreCfg.fromPartial(object.wapp_core_cfg)
      : undefined;
    return message;
  },
};

function createBaseUiRemoteCfg(): UiRemoteCfg {
  return {
    dashboard: undefined,
    plan: undefined,
    financials: undefined,
    analysis: undefined,
    settings: undefined,
    settings_billing: undefined,
  };
}

export const UiRemoteCfg: MessageFns<UiRemoteCfg> = {
  encode(message: UiRemoteCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dashboard !== undefined) {
      UiRemoteCfgtem.encode(message.dashboard, writer.uint32(10).fork()).join();
    }
    if (message.plan !== undefined) {
      UiRemoteCfgtem.encode(message.plan, writer.uint32(18).fork()).join();
    }
    if (message.financials !== undefined) {
      UiRemoteCfgtem.encode(message.financials, writer.uint32(26).fork()).join();
    }
    if (message.analysis !== undefined) {
      StripeRemoteCfgAnalysis.encode(message.analysis, writer.uint32(34).fork()).join();
    }
    if (message.settings !== undefined) {
      UiRemoteCfgtem.encode(message.settings, writer.uint32(42).fork()).join();
    }
    if (message.settings_billing !== undefined) {
      UiRemoteCfgtem.encode(message.settings_billing, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UiRemoteCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiRemoteCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dashboard = UiRemoteCfgtem.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plan = UiRemoteCfgtem.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.financials = UiRemoteCfgtem.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analysis = StripeRemoteCfgAnalysis.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.settings = UiRemoteCfgtem.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.settings_billing = UiRemoteCfgtem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiRemoteCfg {
    return {
      dashboard: isSet(object.dashboard) ? UiRemoteCfgtem.fromJSON(object.dashboard) : undefined,
      plan: isSet(object.plan) ? UiRemoteCfgtem.fromJSON(object.plan) : undefined,
      financials: isSet(object.financials) ? UiRemoteCfgtem.fromJSON(object.financials) : undefined,
      analysis: isSet(object.analysis) ? StripeRemoteCfgAnalysis.fromJSON(object.analysis) : undefined,
      settings: isSet(object.settings) ? UiRemoteCfgtem.fromJSON(object.settings) : undefined,
      settings_billing: isSet(object.settings_billing) ? UiRemoteCfgtem.fromJSON(object.settings_billing) : undefined,
    };
  },

  toJSON(message: UiRemoteCfg): unknown {
    const obj: any = {};
    if (message.dashboard !== undefined) {
      obj.dashboard = UiRemoteCfgtem.toJSON(message.dashboard);
    }
    if (message.plan !== undefined) {
      obj.plan = UiRemoteCfgtem.toJSON(message.plan);
    }
    if (message.financials !== undefined) {
      obj.financials = UiRemoteCfgtem.toJSON(message.financials);
    }
    if (message.analysis !== undefined) {
      obj.analysis = StripeRemoteCfgAnalysis.toJSON(message.analysis);
    }
    if (message.settings !== undefined) {
      obj.settings = UiRemoteCfgtem.toJSON(message.settings);
    }
    if (message.settings_billing !== undefined) {
      obj.settings_billing = UiRemoteCfgtem.toJSON(message.settings_billing);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiRemoteCfg>, I>>(base?: I): UiRemoteCfg {
    return UiRemoteCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiRemoteCfg>, I>>(object: I): UiRemoteCfg {
    const message = createBaseUiRemoteCfg();
    message.dashboard = (object.dashboard !== undefined && object.dashboard !== null)
      ? UiRemoteCfgtem.fromPartial(object.dashboard)
      : undefined;
    message.plan = (object.plan !== undefined && object.plan !== null)
      ? UiRemoteCfgtem.fromPartial(object.plan)
      : undefined;
    message.financials = (object.financials !== undefined && object.financials !== null)
      ? UiRemoteCfgtem.fromPartial(object.financials)
      : undefined;
    message.analysis = (object.analysis !== undefined && object.analysis !== null)
      ? StripeRemoteCfgAnalysis.fromPartial(object.analysis)
      : undefined;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? UiRemoteCfgtem.fromPartial(object.settings)
      : undefined;
    message.settings_billing = (object.settings_billing !== undefined && object.settings_billing !== null)
      ? UiRemoteCfgtem.fromPartial(object.settings_billing)
      : undefined;
    return message;
  },
};

function createBaseUiRemoteCfgtem(): UiRemoteCfgtem {
  return { active: false };
}

export const UiRemoteCfgtem: MessageFns<UiRemoteCfgtem> = {
  encode(message: UiRemoteCfgtem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.active !== false) {
      writer.uint32(8).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UiRemoteCfgtem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiRemoteCfgtem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiRemoteCfgtem {
    return { active: isSet(object.active) ? globalThis.Boolean(object.active) : false };
  },

  toJSON(message: UiRemoteCfgtem): unknown {
    const obj: any = {};
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiRemoteCfgtem>, I>>(base?: I): UiRemoteCfgtem {
    return UiRemoteCfgtem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiRemoteCfgtem>, I>>(object: I): UiRemoteCfgtem {
    const message = createBaseUiRemoteCfgtem();
    message.active = object.active ?? false;
    return message;
  },
};

function createBaseStripeRemoteCfg(): StripeRemoteCfg {
  return { payment_url_annually: "", payment_url_monthly: "", payment_url_customer_portal: "" };
}

export const StripeRemoteCfg: MessageFns<StripeRemoteCfg> = {
  encode(message: StripeRemoteCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.payment_url_annually !== "") {
      writer.uint32(10).string(message.payment_url_annually);
    }
    if (message.payment_url_monthly !== "") {
      writer.uint32(18).string(message.payment_url_monthly);
    }
    if (message.payment_url_customer_portal !== "") {
      writer.uint32(26).string(message.payment_url_customer_portal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StripeRemoteCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStripeRemoteCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.payment_url_annually = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.payment_url_monthly = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.payment_url_customer_portal = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StripeRemoteCfg {
    return {
      payment_url_annually: isSet(object.payment_url_annually) ? globalThis.String(object.payment_url_annually) : "",
      payment_url_monthly: isSet(object.payment_url_monthly) ? globalThis.String(object.payment_url_monthly) : "",
      payment_url_customer_portal: isSet(object.payment_url_customer_portal)
        ? globalThis.String(object.payment_url_customer_portal)
        : "",
    };
  },

  toJSON(message: StripeRemoteCfg): unknown {
    const obj: any = {};
    if (message.payment_url_annually !== "") {
      obj.payment_url_annually = message.payment_url_annually;
    }
    if (message.payment_url_monthly !== "") {
      obj.payment_url_monthly = message.payment_url_monthly;
    }
    if (message.payment_url_customer_portal !== "") {
      obj.payment_url_customer_portal = message.payment_url_customer_portal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StripeRemoteCfg>, I>>(base?: I): StripeRemoteCfg {
    return StripeRemoteCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StripeRemoteCfg>, I>>(object: I): StripeRemoteCfg {
    const message = createBaseStripeRemoteCfg();
    message.payment_url_annually = object.payment_url_annually ?? "";
    message.payment_url_monthly = object.payment_url_monthly ?? "";
    message.payment_url_customer_portal = object.payment_url_customer_portal ?? "";
    return message;
  },
};

function createBaseWappCoreCfg(): WappCoreCfg {
  return { lp_url: "" };
}

export const WappCoreCfg: MessageFns<WappCoreCfg> = {
  encode(message: WappCoreCfg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lp_url !== "") {
      writer.uint32(10).string(message.lp_url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WappCoreCfg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWappCoreCfg();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lp_url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WappCoreCfg {
    return { lp_url: isSet(object.lp_url) ? globalThis.String(object.lp_url) : "" };
  },

  toJSON(message: WappCoreCfg): unknown {
    const obj: any = {};
    if (message.lp_url !== "") {
      obj.lp_url = message.lp_url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WappCoreCfg>, I>>(base?: I): WappCoreCfg {
    return WappCoreCfg.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WappCoreCfg>, I>>(object: I): WappCoreCfg {
    const message = createBaseWappCoreCfg();
    message.lp_url = object.lp_url ?? "";
    return message;
  },
};

function createBaseStripeRemoteCfgAnalysis(): StripeRemoteCfgAnalysis {
  return { active: false, sub_section_map: undefined };
}

export const StripeRemoteCfgAnalysis: MessageFns<StripeRemoteCfgAnalysis> = {
  encode(message: StripeRemoteCfgAnalysis, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.active !== false) {
      writer.uint32(8).bool(message.active);
    }
    if (message.sub_section_map !== undefined) {
      StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection.encode(
        message.sub_section_map,
        writer.uint32(18).fork(),
      ).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StripeRemoteCfgAnalysis {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStripeRemoteCfgAnalysis();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sub_section_map = StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection.decode(
            reader,
            reader.uint32(),
          );
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StripeRemoteCfgAnalysis {
    return {
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      sub_section_map: isSet(object.sub_section_map)
        ? StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection.fromJSON(object.sub_section_map)
        : undefined,
    };
  },

  toJSON(message: StripeRemoteCfgAnalysis): unknown {
    const obj: any = {};
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.sub_section_map !== undefined) {
      obj.sub_section_map = StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection.toJSON(message.sub_section_map);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StripeRemoteCfgAnalysis>, I>>(base?: I): StripeRemoteCfgAnalysis {
    return StripeRemoteCfgAnalysis.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StripeRemoteCfgAnalysis>, I>>(object: I): StripeRemoteCfgAnalysis {
    const message = createBaseStripeRemoteCfgAnalysis();
    message.active = object.active ?? false;
    message.sub_section_map = (object.sub_section_map !== undefined && object.sub_section_map !== null)
      ? StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection.fromPartial(object.sub_section_map)
      : undefined;
    return message;
  },
};

function createBaseStripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection(): StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection {
  return { pnl: false, revenues: false, cf_n_debt: false, nwc: false, bs: false, kpis: false, accounts: false };
}

export const StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection: MessageFns<
  StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection
> = {
  encode(
    message: StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.pnl !== false) {
      writer.uint32(8).bool(message.pnl);
    }
    if (message.revenues !== false) {
      writer.uint32(16).bool(message.revenues);
    }
    if (message.cf_n_debt !== false) {
      writer.uint32(24).bool(message.cf_n_debt);
    }
    if (message.nwc !== false) {
      writer.uint32(32).bool(message.nwc);
    }
    if (message.bs !== false) {
      writer.uint32(40).bool(message.bs);
    }
    if (message.kpis !== false) {
      writer.uint32(48).bool(message.kpis);
    }
    if (message.accounts !== false) {
      writer.uint32(56).bool(message.accounts);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pnl = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.revenues = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cf_n_debt = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nwc = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.bs = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.kpis = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.accounts = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection {
    return {
      pnl: isSet(object.pnl) ? globalThis.Boolean(object.pnl) : false,
      revenues: isSet(object.revenues) ? globalThis.Boolean(object.revenues) : false,
      cf_n_debt: isSet(object.cf_n_debt) ? globalThis.Boolean(object.cf_n_debt) : false,
      nwc: isSet(object.nwc) ? globalThis.Boolean(object.nwc) : false,
      bs: isSet(object.bs) ? globalThis.Boolean(object.bs) : false,
      kpis: isSet(object.kpis) ? globalThis.Boolean(object.kpis) : false,
      accounts: isSet(object.accounts) ? globalThis.Boolean(object.accounts) : false,
    };
  },

  toJSON(message: StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection): unknown {
    const obj: any = {};
    if (message.pnl !== false) {
      obj.pnl = message.pnl;
    }
    if (message.revenues !== false) {
      obj.revenues = message.revenues;
    }
    if (message.cf_n_debt !== false) {
      obj.cf_n_debt = message.cf_n_debt;
    }
    if (message.nwc !== false) {
      obj.nwc = message.nwc;
    }
    if (message.bs !== false) {
      obj.bs = message.bs;
    }
    if (message.kpis !== false) {
      obj.kpis = message.kpis;
    }
    if (message.accounts !== false) {
      obj.accounts = message.accounts;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection>, I>>(
    base?: I,
  ): StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection {
    return StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection>, I>>(
    object: I,
  ): StripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection {
    const message = createBaseStripeRemoteCfgAnalysis_StripeRemoteCfgAnalysisSubSection();
    message.pnl = object.pnl ?? false;
    message.revenues = object.revenues ?? false;
    message.cf_n_debt = object.cf_n_debt ?? false;
    message.nwc = object.nwc ?? false;
    message.bs = object.bs ?? false;
    message.kpis = object.kpis ?? false;
    message.accounts = object.accounts ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
